/* eslint-disable padding-line-between-statements */

/* eslint-disable no-warning-comments */
/* eslint-disable max-len */
/* eslint-disable no-param-reassign */
import React, {
    useContext, useCallback, useState, useEffect
} from 'react';
import _ from 'lodash';
import appConfig from 'app-config';
import { WizardPage, wizardProps } from '@xengage/gw-portals-wizard-react';
import { useDataRefresh, ViewModelForm, ViewModelServiceContext } from '@xengage/gw-portals-viewmodel-react';
import { useDependencies } from '@xengage/gw-portals-dependency-react';
import { FormattedMessage, useTranslator } from '@jutro/locale';
import { MLMultiLobsDataHolderService, MLHistoryService, MLPortalStorageService } from 'ml-services-common-react';
import {UserService} from 'gw-capability-gateway';
import PATrackEvent from 'gw-capability-gateway-quoteandbind-common-react/components/TrackEvent/PATrackEvent';
import { MLAlertGroupComponent} from 'ml-components-common-react';
import { FormModalPopover, platformMessages } from 'ml-components-platform-react';
import { MLNotificationBlockUtil, MLWizardNavUtil } from 'ml-portals-util-react';
import { useAuthentication } from '@xengage/gw-digital-auth-react';
import { useValidation } from '@xengage/gw-portals-validation-react';
import { MLModalService } from 'ml-portals-services-react';
import { MLHVQDiscrepanciesUtil ,MLErrorMessageUtil } from 'ml-portals-util-js';
import { MLDriverVehicleUtil } from 'ml-portals-util-react';
import { useModal } from '@jutro/components';
import { AccountService } from 'gw-capability-gateway-policy';


import {
    PriorMetSubmissionPopup,
    PriorMetSubmissionPopupMessages,
    PriorMetSubmissionPopupStyles
} from 'ml-capability-quoteandbind-common-react';

import { ScrollToError } from '@jutro/legacy/wizard-next';

import MLCRDriversValidationComponent from '../../components/MLCRDriversValidationComponent/MLCRDriversValidationComponent';
import MLCRVehiclesValidationComponent from '../../components/MLCRVehiclesValidationComponent/MLCRVehiclesValidationComponent';
import MLCRPriorInsuranceValidationComponent from '../../components/MLCRPriorInsuranceValidationComponent/MLCRPriorInsuranceValidationComponent';
import MLCRAdditionalInformationComponent from '../../components/MLCRAdditionalInformationComponent/MLCRAdditionalInformationComponent';

import metadata from './GatewayCompRaterValidateInformationPage.metadata.json5';
import messages from './GatewayCompRaterValidateInformationPage.messages';
import styles from './GatewayCompRaterValidateInformationPage.module.scss';

const PA_MODIFIER_PATH = 'lobData.personalAuto.modifiers_ML';

function GatewayCompRaterValidateInformationPage(props) {
    const {
        wizardData: submissionVM,
        updateWizardData,
        currentStep,
        goNext,
        isSkipping,
    } = props;

    const { authHeader } = useAuthentication();
    const { refreshData } = useDataRefresh();

    const {nextStepVisited} = MLWizardNavUtil(props);
    const translator = useTranslator();
    const modalApi = useModal();
    const { LoadSaveService } = useDependencies('LoadSaveService');
    const viewModelService = useContext(ViewModelServiceContext);

    const [discrepancyVMs] = useState([]);
    const [discrepancyCategories, setDiscrepancyCategories] = useState([]);

    const [priorInsuranceErrors_Ext, setPriorInsuranceErrors_Ext] = useState([]);
    const [showPriorInsuranceErrors_Ext, setShowPriorInsuranceErrors_Ext] = useState(false);
    const [showValidationErrors, setShowValidationErrors] = useState(false);
    const [errorTimestamp, setErrorTimestamp] = useState(0);
    const [driversMarriedNoSpouse, setDriversMarriedNoSpouse] = useState([]);
    const [vehicleHasNonDiscrepancy, setVehicleHasNonDiscrepancy] = useState([]);
    const [discrepanciesResolved, setDiscrepanciesResolved] = useState(false);
    const [showInvalidEmailError, setShowInvalidEmailError] = useState(false);
    const paModifiers = _.get(submissionVM, PA_MODIFIER_PATH);
    const [displayEmailWarning, setDisplayEmailWarning] = useState(false);
    const [isInitialPageLoadCompleted , setIsInitialPageLoadCompleted] = useState(false);
    const ML_STORAGE_KEY_ALREADY_VISITED = "USER_ALREADY_VISITED"

    const isGpa = appConfig.portalCode === 'GPA';

    const {
        showProgressDialog,
        hideProgressDialog,
        showErrorModal
    } = MLModalService();

    const {
        getLOBPendingDiscrepancyItemVMs,
        getLOBDiscrepancyItemVMs,
        markAllDiscrepancyItemsCompleted,
        getPropertyVMsFromVMItemWithDefaultSelection,
        isVehicleItemVM,
        isDriverItemVM,
    } = MLHVQDiscrepanciesUtil();

    const {
        checkUniqueSelf,
        checkUniqueSpouse,
    } = MLDriverVehicleUtil();

    const {
        clearErrorAlerts,
        addInfoAlert,
        addWarningAlert,
        addErrorAlert,
        clearBlockAlerts
    } = MLNotificationBlockUtil();

    const [questionSetSyncing, setQuestionSetSyncing] = useState(false);
    const [questionSetSyncPromise, setQuestionSetSyncPromise] = useState(null);
    const quoteID = submissionVM.quoteID.value;

    const getNextStepText = () => {
        let baseMsg = messages.baseCRWizardMessage;
        let boldMsg = messages.nextButtonMessageToQuoteDetail;

        return (
            <FormattedMessage
                {...baseMsg}
                values={{
                    nextStep: (
                        <strong>{translator(boldMsg)}</strong>
                    )
                }}
            />
        );
    };

    // Treat marital status and relationship to ensured as non-discrepancy items if
    // they are not listed as discrepancy items.  This prevents these items from being
    // lost if a spouse is chosen and then discrepancies are resolved
    const resolveMaritalStatusAndRelationship = (hvqDriver, subDriver, discrepancies) => {
        if (discrepancies && discrepancies.length > 0) {
            const driverDiscrepancies = discrepancies.find((disc) =>  disc.publicID === hvqDriver.publicID )
            if (!driverDiscrepancies || !driverDiscrepancies.maritalStatus) {
                hvqDriver.maritalStatus_ML = subDriver.maritalStatus_ML;
            }

            if ((!driverDiscrepancies || !driverDiscrepancies.relationshipToInsured) && subDriver.relationshipToInsured_ML !== null) {
                hvqDriver.relationshipToInsured_ML = subDriver.relationshipToInsured_ML;
            }
        }
    };

    // If a new driver exists before resolving discrepancies, it needs to be 
    // added back to the hvqDiscrepancies list of drivers so it is not lost
    const replaceNewDriversAfterResolvingDiscrepancies = (drivers, hvqDrivers) => {
        drivers.forEach((driver) => {
            if (!!driver.tempID && !driver.publicID) {
                hvqDrivers.push(driver);
            }
        })
    };
    
    const hasDiscrepancies = () => {
        const lobPendingDiscrepancyItemVMs = getLOBPendingDiscrepancyItemVMs(submissionVM);
        return lobPendingDiscrepancyItemVMs.length > 0;
    };

    const resolveDiscrepancies = async (subVM) => {
        // save non-discrepancy data because it won't be returned in the submission model returned from the resolveHVQDiscepancies call
        const vehicles = _.get(subVM, 'lobData.personalAuto.coverables.vehicles.value');
        const drivers = _.get(subVM, 'lobData.personalAuto.coverables.drivers.value');
        const persons = _.get(subVM, 'persons.value');
        const acctHolderEmail = _.get(subVM, 'baseData.accountHolder.emailAddress1.value');
        const pniEmail = _.get(subVM, 'baseData.primaryNamedInsured_ML.emailAddress1.value');
        const commPrefs = _.get(subVM, 'baseData.policyBillingDocCommPref_ML.value.code');
        const lineModifiers = _.get(subVM, 'lobData.personalAuto.modifiers_ML.lineModifiers.value');
        const farmersPrivacyNotice_Ext = _.get(subVM, 'lobData.personalAuto.questionSets_ML.value.privacyDisclaimer.answers.FarmersPrivacyNotice_Ext');
        const paHighestLevelOfEducation_ML = _.get(subVM, 'lobData.personalAuto.questionSets_ML.houseAdditionalInformation.answers.value.PAHighestLevelOfEducation_ML');

        let resolvedHVQ;
        try{
            showProgressDialog(messages.resolveHVQDiscrepancies);
            resolvedHVQ = await LoadSaveService.resolveHVQDiscrepancies(subVM.value, authHeader);
        }catch (error) {
            MLErrorMessageUtil.handleException(error, showErrorModal, messages.somethingWentWrong);
        }

        // now set back the non-discrepancy fields to the model returned from the resolveHVQDiscrepancies call
        _.set(resolvedHVQ, 'baseData.accountHolder.emailAddress1', acctHolderEmail);
        _.set(resolvedHVQ, 'baseData.accountHolder.emailAddress_ML', acctHolderEmail);
        _.set(resolvedHVQ, 'baseData.primaryNamedInsured_ML.emailAddress1', pniEmail);
        _.set(resolvedHVQ, 'baseData.policyBillingDocCommPref_ML', commPrefs);
        _.set(resolvedHVQ, 'lobData.personalAuto.modifiers_ML.lineModifiers', lineModifiers);
        _.set(resolvedHVQ, 'lobData.personalAuto.questionSets_ML.privacyDisclaimer.answers.FarmersPrivacyNotice_Ext', farmersPrivacyNotice_Ext);
        _.set(resolvedHVQ, 'lobData.personalAuto.questionSets_ML.houseAdditionalInformation.answers.PAHighestLevelOfEducation_ML', paHighestLevelOfEducation_ML)

        hideProgressDialog();
        const resolvedVehicles = _.get(resolvedHVQ, 'lobData.personalAuto.coverables.vehicles');
        resolvedVehicles.forEach((resVeh) => {
            const thisVehicle = vehicles.find((veh) => veh.publicID === resVeh.publicID);
            if (thisVehicle) {
                resVeh.purchaseDate_ML = !_.isUndefined(thisVehicle.purchaseDate_ML) ? thisVehicle.purchaseDate_ML : resVeh.purchaseDate_ML;
                resVeh.annualMileage = !_.isUndefined(thisVehicle.annualMileage) ? thisVehicle.annualMileage : resVeh.annualMileage;
                resVeh.parkingType_ML = !_.isUndefined(thisVehicle.parkingType_ML) ? thisVehicle.parkingType_ML : resVeh.parkingType_ML;
                resVeh.vehiclePurchaseDate = !_.isUndefined(thisVehicle.vehiclePurchaseDate) ? thisVehicle.vehiclePurchaseDate : resVeh.vehiclePurchaseDate;
                resVeh.purchasePrice = !_.isUndefined(thisVehicle.purchasePrice) ? thisVehicle.purchasePrice : resVeh.purchasePrice;
            }
        });

        const resolvedDrivers = _.get(resolvedHVQ, 'lobData.personalAuto.coverables.drivers');
        resolvedDrivers.forEach((resDrv) => {
            const thisDriver = drivers.find((drv) => drv.publicID === resDrv.publicID);
            if (thisDriver) {
                resDrv.spouseID_ML= thisDriver.spouseID_ML;
                resolveMaritalStatusAndRelationship(resDrv, thisDriver, submissionVM.hvqDiscrepancies_ML.personalAuto.drivers.value);
            }
        });
        
        // Replace newly added spouse in hvq drivers list before setting back in submissionVM
        replaceNewDriversAfterResolvingDiscrepancies(drivers, resolvedDrivers);
        
        _.set(resolvedHVQ, 'lobData.personalAuto.coverables.vehicles.value', resolvedVehicles);
        // only backfill persons when resolvedHVQ is missing it; never overwrite persons it already has
        if (_.isEmpty(_.get(resolvedHVQ, 'persons')) && !_.isEmpty(persons)) {
            _.set(resolvedHVQ, 'persons', persons);
        }
        _.set(submissionVM, 'value', resolvedHVQ);
    };

    const showPriorInsuranceErrors = () => {
        clearBlockAlerts('priorInsuranceErrors');
        if (priorInsuranceErrors_Ext.length !== 0) {
            priorInsuranceErrors_Ext.forEach((error) => {
                addErrorAlert(error, 'priorInsuranceErrors');
            });
            window.scrollTo(0, 0);
        }
    };

    // Modifiers validation check
    const onUpdateModifiersUnsuccessful = useCallback(() => {
        if (!submissionVM.aspects.valid || !submissionVM.aspects.subtreeValid) {
            setShowValidationErrors(true);
            setErrorTimestamp(errorTimestamp+1);

            return false;
        }
    }, [submissionVM, setShowValidationErrors, setErrorTimestamp]);

    // Prior Insurance
    const onUpdatePiorInsuranceErrors_Ext = (val) => {
        setPriorInsuranceErrors_Ext(val);
    };

    const onUpdateEmail = useCallback((email) => {
        clearBlockAlerts('electronicToPaper');

        if (_.get(submissionVM, 'baseData.policyBillingDocCommPref_ML.value.code') === 'electronic' && !email) {
            setTimeout(() => {
                addWarningAlert(translator(messages.electronicToPaperWarning), 'electronicToPaper');
                window.scrollTo(0, 0);
            },100);

        }
    },[submissionVM, clearBlockAlerts, addWarningAlert, translator]);

    const shouldShowPriorFarmersModal = () => {
        const priorInsuranceQuestionSetData = _.get(submissionVM, 'lobData.personalAuto.questionSets_ML.priorInsurance.value');
        const answers = _.get(priorInsuranceQuestionSetData,"answers.CurrentInsuranceProvider_ML");
        const priorIsFarmers =  (answers === 'MultLineCurrentInsuranceProviderFarmers_Ext' || answers === 'MultLineCurrentInsuranceProviderMetLifePropCas_Ext');
        const hasAnsweredQuestion = !_.isUndefined(submissionVM.baseData.newPolicyReason_Ext.value)
        return priorIsFarmers && !hasAnsweredQuestion;
    };

    const showPriorMetSubmissionModal = () => {
        const disableButton = () => {
            return _.isUndefined(_.get(submissionVM, 'baseData.newPolicyReason_Ext.value', undefined));
        };

        const mapAvailableValues = (values) => {
            if (submissionVM.isSubmitAgent.value === true) {
                values = values.filter((reason) => reason.code !== 'purchase_direct');
            }

            return values.map((type) => {
                return {
                    code: type.code,
                    name: translator({
                        id: type.name,
                        defaultMessage: type.name
                    })
                };
            });
        };

        const newPolicyReasonHelpTextMap = {
            insuring_same_location_diff_policy_form: translator(PriorMetSubmissionPopupMessages.sameLocationPriorMetTooltipContent)
        };

        const newPolicyReasonHelpTextTitleMap = {
            insuring_same_location_diff_policy_form: translator(PriorMetSubmissionPopupMessages.sameLocationPriorMetTooltipTitle)
        };

        const overrides = {
            newPolicyReasonRadioButtons: {
                helpTextTitleMap: newPolicyReasonHelpTextTitleMap,
                helpTextMap: newPolicyReasonHelpTextMap,
                availableValues: mapAvailableValues(_.get(submissionVM, 'baseData.newPolicyReason_Ext.aspects.availableValues', [])),
                value: _.get(submissionVM, 'baseData.newPolicyReason_Ext.value')
            }
        };

        const componentProps = {
            title: translator(PriorMetSubmissionPopupMessages.priorMetPopupHeader),
            uiProps: PriorMetSubmissionPopup.pageContent,
            actionBtnLabel: platformMessages.mlContinue,
            viewModel: submissionVM.baseData,
            disableButton: disableButton,
            modalBodyStyles: PriorMetSubmissionPopupStyles,
            overrideProps: overrides,
            onSaveAction: (onNext),
            showXCloseButton: false
        };

        modalApi.showModal(
            <FormModalPopover {...componentProps} />
        );
    };

    const showPriorCarrierMessage = () => {
        return !_.isEmpty(submissionVM.lobData.personalAuto.questionSets_ML.priorInsurance.readOnlyAnswers_Ext.value)
    };

    const showIMFWarning = () => {
        if (submissionVM?.imfWarnings?.value?.length > 0) {
            return true;
        }

        return false;
    };

    const driverList = _.get(submissionVM, 'lobData.personalAuto.coverables.drivers.value', []);
    const areDriversValid = () => {
        const driversVM = _.get(submissionVM, 'lobData.personalAuto.coverables.drivers.children');
        const isModernProduct = _.get(submissionVM, "isModernProduct_Ext.value", false)
        let allDriversValid = true;
        driversVM.forEach((driverVM) => {
            const highestEducation = driverVM?.highestEducationLevel_Ext?.value
            const isPNIorSpouse = (driverVM.relationshipToInsured_ML?.value?.code === 'self' || driverVM.relationshipToInsured_ML?.value?.code === 'spouse')
            if (!driverVM.aspects.subtreeValid || (isModernProduct && isPNIorSpouse && (highestEducation === undefined || highestEducation === null))) {
                allDriversValid = false;
            }
        });

        if (!checkUniqueSpouse(driverList)) {
            addErrorAlert(translator(messages.duplicateSpouseReturnToPrefillError), 'duplicate-spouse');
            return false;
        }

        const isValid = checkUniqueSelf(driverList) && allDriversValid;
        return isValid;
    };

    const validateDriversChangedToMarriedHaveSpouse = () => {
        const drivers = _.get(submissionVM, 'lobData.personalAuto.coverables.drivers.children', []);
        const driversDiscrepancy = _.get(discrepancyCategories, 'drivers', []);
        let driverChangedToMarriedAndSpouseSelected = true;

        clearBlockAlerts('no-spouse');

        const driverHasDiscrepancy = (driverVM) => {
            return driversDiscrepancy.some((disVM) => {
                const {publicId} = disVM;

                return driverVM.value.publicID === publicId;
            });
        };

        const getDriverDiscrepancy = (driverVM) => {            
            return driversDiscrepancy.find((disVM) => {
                return driverVM.value.publicID === disVM.publicId;
            });           
        };

        const driverQuotedSingleButChoseMarried = (discrepancy) => {
            if (discrepancy.itemVM.maritalStatus.quoteValue?.value === 'Married/Civil Union'
               && !discrepancy.itemVM.maritalStatus.keepHvqValue.value) {
                return true;
            }
            
            return false;            
        }

        drivers.forEach((driverVM) => {
            if (driverHasDiscrepancy(driverVM)) {
                const discrepancy = getDriverDiscrepancy(driverVM);
                
                if (driverQuotedSingleButChoseMarried(discrepancy)
                    && !driverVM.spouseID_ML.value) {
                        addErrorAlert(`${driverVM.value.displayName} ${translator(messages.changedToMarriedButNoSpouse)}`, 'no-spouse')
                        driverChangedToMarriedAndSpouseSelected = false;
                }
            }
        })

        return driverChangedToMarriedAndSpouseSelected
    };

    const areVehiclesValid = () => {
        const vehiclesVM = _.get(submissionVM, 'lobData.personalAuto.coverables.vehicles.children');
        let allVehiclesValid = true;
        vehiclesVM.forEach((vehVM) => {
            if(!vehVM.aspects.subtreeValid) {
                allVehiclesValid = false;
            }
        });

        return allVehiclesValid;
    }

    const {
        onValidate,
        isComponentValid
    } = useValidation('GatewayCompRaterValidateInformationPage');

    const showPageErrors = () => {
        return !isComponentValid || showPriorInsuranceErrors_Ext || showValidationErrors;
    }

    const skipOnResumeIf = () => {
        if (!(submissionVM.hvqQuoteID_ML && submissionVM.hvqQuoteID_ML.value)) {
            return true;
        }

        if (!!_.get(submissionVM, 'bindData.policyNumber.value')
            && (submissionVM.value.baseData.status_ML === 'Bound' || submissionVM.value.baseData.status_ML === 'Binding')) {
            return true;
        }

        if (MLMultiLobsDataHolderService.getLastVisitedStep() === 'quoteDetails' &&
            submissionVM.hvqQuoteID_ML.value &&
            submissionVM.isBundle_ML.value) {
            return true;
        }

        if (submissionVM.hvqQuoteID_ML.value) {
            return MLMultiLobsDataHolderService.hasCompletedStep(currentStep.mlStepName);
        }

        return false;
    }

    const goToNextStep = async (calledFromPopUp = false) => {
        _.set(submissionVM, 'portalCurrentStep_ML.value', currentStep.mlStepName);
        
        // Hide any existing modals before continuing.
        hideProgressDialog();
        showProgressDialog(platformMessages.saveSubmission);

        let res;
        try {
            const submissionData = await LoadSaveService.assignPolicyNumbersToModifiers(submissionVM.value, authHeader);
            _.set(paModifiers.lineModifiers, 'value', submissionData.lobData.personalAuto.modifiers_ML.lineModifiers);
            updateWizardData(submissionVM);
            // As updateDraftSubmission is removing crucial properties that needed in CR PA Validate Info
            // page from the beforeSave method, so need to make a full clone of the submission data
            // to prevent data reference is lost when page re-render before leave page
            const copiedSubmission = _.cloneDeep(submissionVM.value);
            // MUST revert the bypass flag so that PC will remove the eletronic discount if there has no email specified
            _.set(copiedSubmission, 'bypassValidationForComprater_Ext', false);
            allowFlowWithoutSignalNumber(copiedSubmission);
            res = await LoadSaveService.updateDraftSubmission(copiedSubmission, authHeader);
        } catch (error) {
            const bracketContent = error.baseError.match(/\[([^\]]+)\]/);
            if (error.baseError && error.baseError.indexOf('ConcurrentDataChangeException') > -1) {
                hideProgressDialog();
                showErrorModal(null, messages.somethingWentWrong)

                return false;
            } else if(error.baseError){
                if (bracketContent) {
                    showErrorModal('', bracketContent[1], messages.closeWindow);
                }
                return false;
            } else if(error.error.cause) {
                hideProgressDialog();
                showErrorModal(null, error.error.cause.message);
                return false;
            } else {
                throw error;
            }
        } finally {
            hideProgressDialog();
            if (res) {
                submissionVM.value = res;
                allowFlowWithoutSignalNumber(submissionVM.value);
                updateWizardData(submissionVM);
            }
            MLMultiLobsDataHolderService.storeFlowSteps(currentStep.mlStepName, 'quoteCompRaterDetails', authHeader);
        }

        if (!nextStepVisited() && !calledFromPopUp) {
            return submissionVM;
        }

        goNext();

        return false;
    }

    const allowFlowWithoutSignalNumber = (submissionData) => {
        let drivers = submissionData?.lobData?.personalAuto?.coverables?.drivers;
        if (Array.isArray(drivers)) {
            const targetCodes = [
                "PADriverSignalProgramPhoneNumber_Ext"
            ];

            drivers.forEach((driver) => {
                const modifiers = driver?.driverModifiers_ML?.modifiers;
                if (Array.isArray(modifiers)) {
                    modifiers.forEach((modifier) => {
                        if (modifier && targetCodes.includes(modifier.codeIdentifier_ML)) {
                            modifier.chosenTermValue = null;
                            modifier.isVisible_ML = false
                            modifier.isInputValueRequired_ML = false
                            modifier.editMode_ML = false
                            modifier.savedFromPortal = false
                        }
                    });
                }
            });
        }
    }

    const setEditMode = (editMode) => submissionVM.value.lobData.personalAuto.coverables.drivers.forEach((driver) => {
        driver.editMode_ML = editMode;
    });

    const validateAdditionInfoQuestions = useCallback(() => {
        const requiredQuestionSets_ML = ["FarmersSubCompany_Ext","TenureOriginalEffDate_Ext","CompanyPolicyNumber_Ext",];
        let flag = false

        clearBlockAlerts('additionInfoQuestions')
        const priorInsuranceQuestions = _.get(submissionVM.value, 'lobData.personalAuto.questionSets_ML.priorInsurance', {});
        requiredQuestionSets_ML.forEach((item) => {
            const requiredQuestion =Object.entries(priorInsuranceQuestions.answers).find(([key, value]) => key === item);
            
            if (requiredQuestion && !_.isEmpty(requiredQuestion)) {
                if ((_.isNil(requiredQuestion[1]) ||
                    _.isEmpty(requiredQuestion[1]))) {
                    addErrorAlert(translator(messages[item]),'additionInfoQuestions');
                    flag = true
                }
            }
        });

        return flag

    }, [addErrorAlert, clearBlockAlerts, submissionVM.value, translator]);

    const showFarmersPrivacyNoticerValue = () => {
        return submissionVM.baseData.productCode.value === "PersonalAuto";
    }

    const checkQuestionSetSync = (serviceCall) => {
        let updatePromise;
        if (questionSetSyncing && questionSetSyncPromise) {
            console.log("Waiting for questionSetSyncing to finish...")
            updatePromise = questionSetSyncPromise.then(() => {
                const promise = serviceCall();
                setTimeout(() => {
                    showProgressDialog(platformMessages.syncingQuestions, promise, true);
                }, 0);
                return promise;
            });
        } else {
            showProgressDialog(platformMessages.syncingQuestions, updatePromise, true);
            updatePromise = serviceCall();            
        }
        setQuestionSetSyncing(true);
        setQuestionSetSyncPromise(updatePromise);
        return updatePromise;
    };

    const createPayloadToSyncQuestionSet = () => {
        // mark as false if user didnt answer the question
        if(_.get(submissionVM, 'lobData.personalAuto.questionSets_ML.value.privacyDisclaimer.answers.FarmersPrivacyNotice_Ext') === undefined || 
            _.get(submissionVM, 'lobData.personalAuto.questionSets_ML.value.privacyDisclaimer.answers.FarmersPrivacyNotice_Ext') === null){
            _.set(submissionVM, 'lobData.personalAuto.questionSets_ML.value.privacyDisclaimer.answers.FarmersPrivacyNotice_Ext', "false")
        }
        const question = _.get(submissionVM, "lobData.personalAuto.questionSets_ML.value.privacyDisclaimer");
        return question;
    }

    const syncQuestionSets = async () => {
        const aQuestionSetAnswersValue = createPayloadToSyncQuestionSet();
        const { code } = aQuestionSetAnswersValue;

        if (code && code === "PrivacyDisclaimer_ML") {

            try {
                showProgressDialog(platformMessages.syncingQuestions);
                const updatedQuestions = await LoadSaveService.syncQuestionSetML(quoteID, [aQuestionSetAnswersValue], authHeader); // <-- Await here
                const newVm = viewModelService.clone(submissionVM);
                const transformedQuestions = {};

                updatedQuestions.forEach((q) => { transformedQuestions[q.code] = q; });

                if (code === "PrivacyDisclaimer_ML") {
                    _.set(newVm, 'lobData.personalAuto.questionSets_ML.privacyDisclaimer.value', transformedQuestions.PrivacyDisclaimer_ML);
                }

                updateWizardData(newVm);
            }catch (error) {
                MLErrorMessageUtil.handleException(error, showErrorModal, messages.somethingWentWrong);
            }finally {
                hideProgressDialog();
                setQuestionSetSyncPromise(null);
                setQuestionSetSyncing(false);
            }
        }
    };

    const onNext = async () => {
        const isValidEmail = await validateEmailAddress();
        if(!isValidEmail)
            return false;
        UserService.getCurrentUser(authHeader).then((user) => {
            PATrackEvent('Quote Step Submitted', false, submissionVM, user, {step: 'Gateway CompRater Validation Page', action: 'CompRater Auto Validation Page Submitted'});
        });

        if (!validateDriversChangedToMarriedHaveSpouse()) {
            return false
        }

        // Remove electronic discount when email is not provided
        if ((_.get(submissionVM, 'baseData.policyBillingDocCommPref_ML.value.code') === 'electronic')
            && !_.get(submissionVM, 'baseData.primaryNamedInsured_ML.emailAddress1.value')) {
                _.set(submissionVM, 'baseData.policyBillingDocCommPref_ML.value', 'paper');
        }

        const drivers = _.get(submissionVM, 'lobData.personalAuto.coverables.drivers.value');
        const primaryNamedDriver = drivers.find((driver) => driver.relationshipToInsured_ML === 'self');
        const primaryNamedInsured = _.get(submissionVM, 'baseData.primaryNamedInsured_ML.value');

        if (drivers && drivers.length) {

            if (primaryNamedDriver && primaryNamedDriver.person && (primaryNamedDriver.person.publicID === primaryNamedInsured.publicID)) {
                primaryNamedDriver.person.emailAddress_ML = primaryNamedInsured.emailAddress1;
            }
        }

        if (primaryNamedInsured.publicID === submissionVM.baseData.accountHolder.publicID.value) {
            submissionVM.baseData.accountHolder.value = primaryNamedInsured;
        }

        clearErrorAlerts();
        allowFlowWithoutSignalNumber(submissionVM.value);
        setEditMode(false);
        if (!isComponentValid || !submissionVM.aspects.valid || !submissionVM.aspects.subtreeValid) {
            if (priorInsuranceErrors_Ext.length !== 0) {
                showPriorInsuranceErrors()
            }
            setShowPriorInsuranceErrors_Ext(true)
            setShowValidationErrors(true);
            setTimeout(()=>{
                setErrorTimestamp(errorTimestamp+1);
            }, 500);

            return false;
        }

        if(validateAdditionInfoQuestions()){
            return false
        }
        
        if (!areVehiclesValid()) {
            setShowValidationErrors(true);
            setTimeout(()=>{
                setErrorTimestamp(errorTimestamp+1);
            }, 500);
            return false;
        }

        if (priorInsuranceErrors_Ext.length !== 0) {
            showPriorInsuranceErrors()
            setTimeout(()=>{
                setErrorTimestamp(errorTimestamp+1);
            }, 500);
            return false;
        }

        if(hasDiscrepancies()) {
            // Resolve all discrepencies before run validation check
            markAllDiscrepancyItemsCompleted(submissionVM);
            await resolveDiscrepancies(submissionVM);
            
            // Use this to hide driver discrepancies once they have been resolved since 
            // they won't be resolved again even if below validations fail.
            setDiscrepanciesResolved(true);
        }

        if (!areDriversValid() || driverMarriedWithNoSpouse()) {
            setShowValidationErrors(true);
            setTimeout(()=>{
                setErrorTimestamp(errorTimestamp+1);
            }, 500)
            
            return false;
        }

        // The flow step update should be started only when this page is successfully pass and data has submitted correctly
        // The below logic is execute in goToNextStep the finally block
        // MLMultiLobsDataHolderService.storeFlowSteps(currentStep.mlStepName, 'quoteCompRaterDetails', authHeader);

        if (shouldShowPriorFarmersModal()) {
            showPriorMetSubmissionModal();
            return false;
        }

        if(showFarmersPrivacyNoticerValue()){
            await syncQuestionSets();
            const jsonData = {  alreadyVisited: true };
            MLPortalStorageService.store(submissionVM.quoteID.value, null, ML_STORAGE_KEY_ALREADY_VISITED, JSON.stringify(jsonData), authHeader);
        }
        // return false;
        return goToNextStep();
    };

    const driverMarriedWithNoSpouse = () => {
        const drivers = _.get(submissionVM, 'lobData.personalAuto.coverables.drivers.children', []);
    
        const driverHasAValidSpouse = (driverVM) => {
            return !_.isUndefined(driverVM.value.spouseID_ML) && drivers.some((dVM) => {
                return (dVM.value.person.publicID === driverVM.value.spouseID_ML)
                    || (dVM.value.person.tempID === driverVM.value.spouseID_ML)
            });
        }
    
        const driverHasNoSpouse = drivers.some((driverVM) => {
            const driverIsMarriedButNoSpouse = (!!driverVM.maritalStatus_ML.value && driverVM.maritalStatus_ML.value.code === 'M' && driverVM.type_ML.value.code === 'rated')
                && !driverHasAValidSpouse(driverVM);
    
            return driverIsMarriedButNoSpouse;
        });
    
        return driverHasNoSpouse;
    }

    const filterDriversByDiscrepancyOrModifiers = () => {
        const drivers = _.get(submissionVM, 'lobData.personalAuto.coverables.drivers.children', []);
        const driversDiscrepancy = _.get(discrepancyCategories, 'drivers', []);

        const driverHasAValidSpouse = (driverVM) => {
            return !_.isUndefined(driverVM.value.spouseID_ML) && drivers.some((dVM) => dVM.value.person.publicID === driverVM.value.spouseID_ML);
        }

        const driverAddedToMarriedNoSpouse = (driverVM) => {
            return driversMarriedNoSpouse.some((driverPublicID) => driverPublicID === driverVM.publicID.value)
        }

        const driversVMHasDiscrepancyOrModifiers = drivers.filter((driverVM) => {
            // Check if driver has either modifiers or a corresponding discrepancy
            const hasModifiers = driverVM.driverModifiers_ML && driverVM.driverModifiers_ML?.modifiers?.children?.length > 0;
            const hasDriverDiscrepancies = driversDiscrepancy.some((disVM) => {
                const publicId = disVM.publicId;
                return driverVM.value.publicID === publicId;
            });

            const driverIsMarriedButNoSpouse = (!!driverVM.maritalStatus_ML.value && driverVM.maritalStatus_ML.value.code === 'M' && driverVM.type_ML.value.code === 'rated')
            && !driverHasAValidSpouse(driverVM);

            if (driverIsMarriedButNoSpouse && !driverAddedToMarriedNoSpouse(driverVM)) {
                setDriversMarriedNoSpouse((previousDriverIDs) => [...previousDriverIDs, _.get(driverVM, 'publicID.value')]);
            }

            return hasModifiers || hasDriverDiscrepancies || driverIsMarriedButNoSpouse || driverAddedToMarriedNoSpouse(driverVM);
        });

        return driversVMHasDiscrepancyOrModifiers;
    }

    const milageIsRequired = (vehVM) => {
        if (
            vehVM.category_ML.value.code === 'private_passenger_light_truck' &&
            vehVM.isAnnualMileageRequired_ML.value &&
            (
                vehVM.hasVendorAnnualMileage_ML.value === false ||
                (vehVM.hasVendorAnnualMileage_ML.value === true && vehVM.disputedVendorAnnualMileage_Ext.value === true)
            ) &&
            vehVM.namedNonOwner_ML.value !== true &&
            vehVM.partialVehicleAdditionFlag_Ext.value !== true
        ){
            return true;
        }
        return false;

    }
    const filterVehiclesByDiscrepancyOrFields = () => {
        const effectiveDate = _.get(submissionVM, 'baseData.periodStartDate.value');
        const vehicles = _.get(submissionVM, 'lobData.personalAuto.coverables.vehicles.children', []);
        const vehiclesDiscrepancy = _.get(discrepancyCategories, 'vehicles', []);

        // Vehicle ownedLessThan6Months_Ext field is undefined when CR bridging, need to give it value to prevent DTO validation error
        const checkOwnedLessThanSixMonths = (vehicleVM) => {
            if (!vehicleVM.purchaseDate_ML) {
                vehicleVM.ownedLessThan6Months_Ext = false;
                return;
            }

            const effectiveMonth = effectiveDate.month + 1;
            const currentYear = new Date().getFullYear();

            if (vehicleVM.purchaseDate_ML.year === currentYear - 1) {
                if (effectiveMonth < 6) {
                    vehicleVM.ownedLessThan6Months_Ext = true;
                } else {
                    vehicleVM.ownedLessThan6Months_Ext = false;
                }
            } else if (vehicleVM.purchaseDate_ML.year === currentYear) {
                if (effectiveMonth > 6) {
                    vehicleVM.ownedLessThan6Months_Ext = true;
                } else {
                    vehicleVM.ownedLessThan6Months_Ext = true;
                }
            } else {
                vehicleVM.ownedLessThan6Months_Ext = false;
            }

            // US832729 Need to manually set the isRequired flag to true
            // This was lost during the move from angular to react
            vehicleVM.isAnnualMileageRequired_ML = true;
            // enforce the parkingType_ML question to be required as CR bridging quote will always blank the value
            // but for some reason the requireness of this question is not set to true by default
            if(vehicleVM.partialVehicleAdditionFlag_Ext) {
                vehicleVM.editMode_ML = true;
                vehicleVM.partialVehicleAdditionFlag_Ext = false;
            }
        };

        vehicles.forEach((vehVM) => checkOwnedLessThanSixMonths(vehVM));

        const vehiclesVMHasDiscrepancyOrModifiers = vehicles.filter((vehicleVM) => {
            const parkingTypeIsUndefined = _.isUndefined(vehicleVM.parkingType_ML.value);
            const mileageShouldShow = _.isUndefined(vehicleVM.annualMileage.value) && milageIsRequired(vehicleVM);

            const purchaseDateIsUndefined = _.isUndefined(vehicleVM.purchaseDate_ML.value);

            const hasVehicleDiscrepancies = vehiclesDiscrepancy.some((disVM) => {
                const publicId = disVM.publicId;
                return vehicleVM.value.publicID === publicId;
            });

            return parkingTypeIsUndefined || mileageShouldShow || purchaseDateIsUndefined || hasVehicleDiscrepancies || vehicleHasNonDiscrepancy;
        });

        return vehiclesVMHasDiscrepancyOrModifiers;
    }

    const validateEmailAddress = async () => {
        setShowInvalidEmailError(false);
        const account = _.get(submissionVM, 'baseData.primaryNamedInsured_ML');
        let emailAddress1 = _.get(account, 'emailAddress1.value');
        if (emailAddress1) {
            emailAddress1 = emailAddress1.trim();
        }
        const isValidEmailEntered = /^[-!#$%&'*+/0-9=?A-Z^_a-z`{|}~](\.?[-!#$%&'*+/0-9=?A-Z^_a-z`{|}~])*@[a-zA-Z0-9](-*\.?[a-zA-Z0-9])*\.[a-zA-Z](-?[a-zA-Z0-9])+$/.test(emailAddress1)
    
        if (isValidEmailEntered) {
            const checkEmailVerified_Ext = AccountService.checkEmailVerified_Ext(emailAddress1, authHeader);
            try {
                showProgressDialog(platformMessages.loading, checkEmailVerified_Ext, true);
                const res = await checkEmailVerified_Ext;
                hideProgressDialog(platformMessages.loading, checkEmailVerified_Ext, true);
                console.log("Email verification API Called");
                if (res === true) {
                    _.set(account, 'emailVerified_Ext.value', true);
                    _.set(account, 'emailAddress1.value', emailAddress1);
                    return true;
                } else {
                    _.set(account, 'emailVerified_Ext.value', false);
                    _.set(account, 'emailAddress1.value', emailAddress1);
                    setShowInvalidEmailError(true);
                    setShowValidationErrors(true);
                    return false;
                }
            } catch (e) {
                clearBlockAlerts('invalidEmail');
                addWarningAlert(translator(platformMessages.invalidEmail), 'invalidEmail');
                _.set(account, 'emailVerified_Ext.value', false);
                _.set(account, 'emailAddress1.value', emailAddress1);
                setShowInvalidEmailError(false);
                hideProgressDialog(platformMessages.loading, checkEmailVerified_Ext, true);
                console.log(e);
                window.scrollTo(0, 0);
                if(!displayEmailWarning){
                    setDisplayEmailWarning(true);
                    return false;
                }else
                    return true;
            }
        } else {
            if (emailAddress1 !== undefined && emailAddress1 !== "") {
                setShowInvalidEmailError(true);
                setShowValidationErrors(true);
                return false;
            } else {
                return true;
            }
        }
    };

    const checkEmail = (e) => {
        const account = _.get(submissionVM, 'baseData.primaryNamedInsured_ML');
        const emailAddress1 = _.get(account, 'emailAddress1.value');
        if(e?.relatedTarget?.innerText === 'CONTINUE'){
            onNext();
            return;
        }
        if (emailAddress1 === undefined || emailAddress1 === "") {
            
            setShowInvalidEmailError(false);
            setShowValidationErrors(false);
        }
        
    };

    const overrideProps = {
        driversDiscrepancy: {
            submissionVM: submissionVM,
            discrepanciesVM: _.get(discrepancyCategories, 'drivers', []),
            driversVMForDiscrepancy: filterDriversByDiscrepancyOrModifiers(),
            driversVM: _.get(submissionVM, 'lobData.personalAuto.coverables.drivers.children', []),
            onValidate: onValidate,
            showValidationErrors,
            updateWizardData,
            onUpdateModifiersUnsuccessful,
            driversMarriedNoSpouse,
            discrepanciesResolved
        },
        vehiclesDiscrepancy: {
            submissionVM: submissionVM,
            discrepanciesVM: _.get(discrepancyCategories, 'vehicles', []),
            vehiclesVM: filterVehiclesByDiscrepancyOrFields(),
            onValidate: onValidate,
            showValidationErrors
        },
        priorInsurance: {
            submissionVM,
            updateWizardData,
            currentStep,
            onValidate: onValidate,
            showValidationErrors,
            onUpdateErrors: onUpdatePiorInsuranceErrors_Ext,
            showPriorInsuranceErrors: showPriorInsuranceErrors_Ext,
            updateShowPriorInsuranceErrors: setShowPriorInsuranceErrors_Ext,
            showErrors: showPriorInsuranceErrors_Ext
        },
        additionalInfo: {
            submissionVM,
            updateWizardData,
            onValidate: onValidate,
            showValidationErrors,
            onUpdateEmail,
            showInvalidEmailError,
            setShowValidationErrors,
            checkEmail,
            setIsInitialPageLoadCompleted,
            isInitialPageLoadCompleted
            
        }
    };

    const resolvers = {
        resolveCallbackMap: {
            onValidate: onValidate,
        },
        resolveClassNameMap: styles,
        resolveComponentMap: {
            driverDiscrepanciesComponent: MLCRDriversValidationComponent,
            vehicleDiscrepanciesComponent: MLCRVehiclesValidationComponent,
            priorInsuranceComponent: MLCRPriorInsuranceValidationComponent,
            additionalInfoComponent: MLCRAdditionalInformationComponent,
            MLAlertGroupComponent: MLAlertGroupComponent
        }
    }

    useEffect(() => {
        UserService.getCurrentUser(authHeader).then((user) => {
            PATrackEvent('Quote Step Reached', isSkipping, submissionVM, user, {step: 'Gateway CompRater Validation Page'});
        });
        if(showPriorCarrierMessage() || showIMFWarning()) {
            setTimeout(() => addInfoAlert(translator(messages.priorInsuranceInfoMessage), 'priorInsurance'), 100);
        }
        if ((_.get(submissionVM, 'baseData.policyBillingDocCommPref_ML.value.code') === 'electronic')
            && !_.get(submissionVM, 'baseData.primaryNamedInsured_ML.emailAddress1.value')) {
                setTimeout(() => addWarningAlert(translator(messages.electronicToPaperWarning), 'electronicToPaper'), 100);
        }
        window.scrollTo(0, 0);
    }, []);

    useEffect(() => {
        const sniPriorMailingAddressValue = _.get(submissionVM, 'baseData.sniPriorAddressQuestion_Ext.value', undefined)
        if (_.isUndefined(sniPriorMailingAddressValue)) {
            _.set(submissionVM, 'baseData.sniPriorAddressQuestion_Ext.value', false);
        }
        refreshData();
    }, []);

    useEffect(() => {
        if (!isSkipping || (isSkipping && !skipOnResumeIf())) {
            const discrepancyItemVMs = getLOBDiscrepancyItemVMs(submissionVM);
            if (discrepancyItemVMs.length) {
                const lobPendingDiscrepancyItemVMs = getLOBPendingDiscrepancyItemVMs(submissionVM);

                lobPendingDiscrepancyItemVMs.forEach((itemVM) => {
                    discrepancyVMs.push({
                        publicId: itemVM.publicID.value,
                        itemVM,
                        propertyVMs: getPropertyVMsFromVMItemWithDefaultSelection(itemVM)
                    });
                });

                setDiscrepancyCategories({
                    vehicles: discrepancyVMs.filter((discrepacyVM) => isVehicleItemVM(discrepacyVM.itemVM)),
                    drivers: discrepancyVMs.filter((discrepacyVM) => isDriverItemVM(discrepacyVM.itemVM)),
                });
            }

            const initVehicles = _.get(submissionVM, 'lobData.personalAuto.coverables.vehicles.children', []);

            initVehicles.forEach((initVehicleVM) => {
                const initParkingTypeIsUndefined = _.isUndefined(initVehicleVM.parkingType_ML.value);
                const initMileageShouldShow = _.isUndefined(initVehicleVM.annualMileage.value) && milageIsRequired(initVehicleVM);

                const initPurchaseDateIsUndefined = _.isUndefined(initVehicleVM.purchaseDate_ML.value);

                if (initParkingTypeIsUndefined || initMileageShouldShow || initPurchaseDateIsUndefined) {
                    setVehicleHasNonDiscrepancy(true);
                }
            });
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
            if (!isSkipping || (isSkipping && !skipOnResumeIf())) {
                const copiedModel = _.cloneDeep(submissionVM);
                copiedModel.value.lobData.personalAuto.coverables.drivers.forEach((driver) => {
                    driver.editMode_ML = false;
                    const hasModifiers = driver?.driverModifiers_ML && driver?.driverModifiers_ML?.modifiers?.length > 0;

                    if (hasModifiers) {
                        driver.driverModifiers_ML.modifiers.forEach((mod) => {
                            mod.editMode_ML = false;
                        });
                    }
                });
                copiedModel.value.lobData.personalAuto.coverables.vehicles.forEach((vehicle) => {
                    vehicle.editMode_ML = false;
                });
                _.set(copiedModel, 'bypassValidationForComprater_Ext.value', true);
                const multiPolicyPromise = LoadSaveService.assignPolicyNumbersToModifiers(copiedModel.value, authHeader);
                showProgressDialog(platformMessages.syncing, multiPolicyPromise, true);

                multiPolicyPromise.then((submissionData) => {
                    _.set(paModifiers.lineModifiers, 'value', submissionData.lobData.personalAuto.modifiers_ML.lineModifiers);
                    updateWizardData(submissionVM);
                })
            }
        }, []);

    return (
        <WizardPage
            onNext={onNext}
            skipWhen={skipOnResumeIf}
            showCancel={false}
            showPrevious={false}
            showNext={!nextStepVisited()}
            nextLabel={translator(platformMessages.mlContinue)}
            showTextNextToButton={!nextStepVisited()}
            textNextToButton={getNextStepText()}
            metadataPageId={!nextStepVisited() && _.get(metadata, 'pageContent.id')}
            stickyComponentOverrideId='stickyContinueSection'
        >
            <ViewModelForm
                uiProps={metadata.pageContent}
                model={submissionVM}
                overrideProps={overrideProps}
                callbackMap={resolvers.resolveCallbackMap}
                classNameMap={resolvers.resolveClassNameMap}
                componentMap={resolvers.resolveComponentMap}
                onModelChange={updateWizardData}
                onValidationChange={onValidate}
                showErrors={showPageErrors}
            />
            <ScrollToError counter={errorTimestamp} />
        </WizardPage>
    );
}

GatewayCompRaterValidateInformationPage.propTypes = wizardProps;
export default GatewayCompRaterValidateInformationPage;